// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0bf0ae1","453":"79788990","455":"14b9403c","977":"0416707f"}[chunkId] + ".chunk.js";
};